import http from '@/common/utils/http-common';
import { Prefecture } from '@/types/Prefecture.type';

class PrefectureService {
  getAll() {
    return http.get('/prefectures');
  }

  get(id: string) {
    return http.get(`/prefectures/${id}`);
  }
}

export default new PrefectureService();
